import { render } from "./CustomAccountQuickSearchElement.vue?vue&type=template&id=27214dce&scoped=true"
import script from "./CustomAccountQuickSearchElement.vue?vue&type=script&lang=js"
export * from "./CustomAccountQuickSearchElement.vue?vue&type=script&lang=js"

import "./CustomAccountQuickSearchElement.vue?vue&type=style&index=0&id=27214dce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27214dce"]])

export default __exports__